
interface ProgressIndicatorProps {
  progress: number
}

export default function ProgressIndicator({ progress }: ProgressIndicatorProps) {
  const clampedProgress = Math.min(100, Math.max(0, progress))
  
  const getProgressColor = () => {
    if (clampedProgress < 30) return 'bg-red-500'
    if (clampedProgress < 60) return 'bg-yellow-500'
    if (clampedProgress < 90) return 'bg-blue-500'
    return 'bg-green-500'
  }

  return (
    <div className="bg-white rounded-lg p-3">
      <div className="flex justify-between mb-1">
        <span className="text-xs font-medium text-gray-700">Workflow Completion</span>
        <span className="text-xs font-medium text-gray-700">{clampedProgress}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className={`h-2.5 rounded-full transition-all duration-500 ${getProgressColor()}`}
          style={{ width: `${clampedProgress}%` }}
        />
      </div>
      <div className="mt-2 text-xs text-gray-600">
        {clampedProgress === 0 && 'Just getting started...'}
        {clampedProgress > 0 && clampedProgress < 30 && 'Understanding your requirements...'}
        {clampedProgress >= 30 && clampedProgress < 60 && 'Building workflow structure...'}
        {clampedProgress >= 60 && clampedProgress < 90 && 'Refining connections and logic...'}
        {clampedProgress >= 90 && clampedProgress < 100 && 'Almost complete...'}
        {clampedProgress === 100 && '✨ Workflow ready!'}
      </div>
    </div>
  )
}